import { render, staticRenderFns } from "./balanceFrozen.vue?vue&type=template&id=7dc8a466&scoped=true&"
import script from "./balanceFrozen.vue?vue&type=script&lang=js&"
export * from "./balanceFrozen.vue?vue&type=script&lang=js&"
import style0 from "./balanceFrozen.vue?vue&type=style&index=0&id=7dc8a466&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc8a466",
  null
  
)

export default component.exports